export enum VideoPresetEnum {
  Ultrafast = 0,
  Superfast = 1,
  Veryfast = 2,
}

export type VideoPreset =
  | VideoPresetEnum.Ultrafast
  | VideoPresetEnum.Superfast
  | VideoPresetEnum.Veryfast;
